// Generated by scripts/sync-measurement-sdk.cjs from Bullstory Next.
export const NEWSLETTER_LOCALES = [
  'ko-KR',
  'en-US', 'en-GB', 'en-CA', 'en-AU', 'en-IN', 'en-SG',
  'es-ES', 'es-MX',
  'ja-JP',
  'de-DE', 'de-CH',
  'pt-BR', 'fr-FR', 'id-ID',
  'nl-NL', 'nl-BE',
  'sv-SE', 'zh-HK', 'zh-TW',
] as const;

export type NewsletterLocale = (typeof NEWSLETTER_LOCALES)[number];
export type NewsletterLanguage = 'ko' | 'en' | 'es' | 'ja' | 'de' | 'pt' | 'fr' | 'id' | 'nl' | 'sv' | 'zh-Hant';

const LOCALE_SET = new Set<string>(NEWSLETTER_LOCALES);
const LANGUAGE_BY_LOCALE: Record<NewsletterLocale, NewsletterLanguage> = {
  'ko-KR': 'ko',
  'en-US': 'en', 'en-GB': 'en', 'en-CA': 'en', 'en-AU': 'en', 'en-IN': 'en', 'en-SG': 'en',
  'es-ES': 'es', 'es-MX': 'es',
  'ja-JP': 'ja',
  'de-DE': 'de', 'de-CH': 'de',
  'pt-BR': 'pt', 'fr-FR': 'fr', 'id-ID': 'id',
  'nl-NL': 'nl', 'nl-BE': 'nl',
  'sv-SE': 'sv', 'zh-HK': 'zh-Hant', 'zh-TW': 'zh-Hant',
};

export const NEWSLETTER_MARKET_PATH: Record<NewsletterLocale, string> = {
  'ko-KR': '/markets/kr/today',
  'en-US': '/en-us/investing/us-stock-market-today',
  'en-GB': '/en-gb/investing/ftse-100-today',
  'en-CA': '/en-ca/investing/tsx-today',
  'en-AU': '/en-au/investing/asx-200-today',
  'en-IN': '/en-in/investing/nifty-50-today',
  'en-SG': '/en-sg/investing/straits-times-index-today',
  'es-ES': '/es-es/inversion/ibex-35-hoy',
  'es-MX': '/es-mx/inversion/horario-bolsa-mexicana',
  'ja-JP': '/ja-jp/investing/nikkei-225-today',
  'de-DE': '/de-de/boerse/dax-aktuell',
  'de-CH': '/de-ch/boerse/smi-aktuell',
  'pt-BR': '/pt-br/investimentos/ibovespa-hoje',
  'fr-FR': '/fr-fr/bourse/cac-40-aujourdhui',
  'id-ID': '/id-id/investasi/ihsg-hari-ini',
  'nl-NL': '/nl-nl/beleggen/aex-koers',
  'nl-BE': '/nl-be/beleggen/bel20',
  'sv-SE': '/sv-se/investering/borsen-idag',
  'zh-HK': '/zh-hk/investing/hang-seng-index-today',
  'zh-TW': '/zh-tw/investing/taiwan-stock-market-today',
};

const LEGACY_CAMPAIGN_SUFFIX: Partial<Record<NewsletterLocale, string>> = {
  'ko-KR': 'ko', 'en-US': 'en', 'es-ES': 'es', 'ja-JP': 'ja',
};

export const NEWSLETTER_CAMPAIGNS = new Set([
  'company_alert_daily_ko', 'company_alert_daily_en', 'company_alert_daily_es', 'company_alert_daily_ja',
  ...NEWSLETTER_LOCALES.map((locale) => (
    `daily_market_brief_${LEGACY_CAMPAIGN_SUFFIX[locale] || locale.toLowerCase().replace('-', '_')}`
  )),
]);

export function normalizeNewsletterLocale(value: unknown): NewsletterLocale {
  return typeof value === 'string' && LOCALE_SET.has(value) ? value as NewsletterLocale : 'ko-KR';
}

export function newsletterLanguage(locale: NewsletterLocale): NewsletterLanguage {
  return LANGUAGE_BY_LOCALE[locale];
}
